<template lang="pug">
    section#banner
        ul(ref="items", :style="styleItems").items
            li(v-for="image, index in images").item
                Imagem(:content="image")
        .titulo
            h2 {{ content.title }}
            button(v-if="content.video", @click="openVideo(content.video)").action
                FontAwesomeIcon(:icon="icons.faPlay")
                | assista ao vídeo
        ul.redes
            li.rede(v-if="$configuracoes.instagram")
                a(:href="$configuracoes.instagram", target="_blank")
                    FontAwesomeIcon(:icon="icons.faInstagram")
            li.rede(v-if="$configuracoes.facebook")
                a(:href="$configuracoes.facebook", target="_blank")
                    FontAwesomeIcon(:icon="icons.faFacebook")
        .controls(v-if="images.length")
            button(@click="toggleGaleria(ativo - 1)").prev
                FontAwesomeIcon(:icon="icons.faChevronLeft")
            button(@click="toggleGaleria(ativo + 1)").next
                FontAwesomeIcon(:icon="icons.faChevronRight")
</template>

<script>
import { faPlay, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { faFacebookSquare as faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'
import { components } from '@/mixins/components'

export default {
    name: "section-banner",
    components,
    props: {
        content: {
            type: Object,
            required: true
        },
        type: {
            type: String,
            required: true
        },
    },
    data() {
        return {
            icons: {
                faPlay,
                faChevronLeft,
                faChevronRight,
                faFacebook, 
                faInstagram,
            },
            ativo: 1,
            interval: null,
        }
    },
    computed: {
        images() {
            return this.content.images || []
        },
        styleItems() {
            return {
                transform: `translateX(${-(this.ativo - 1) * 100}%)`,
            }
        }
    },
    mounted() {
        this.interval = setInterval(() => {
            this.toggleGaleria(this.ativo + 1)
        }, 6000)
    },
    methods: {
        openVideo(video) {
            this.$eventbus.$emit('asideOpenVideo', video)
        },
        toggleGaleria(index = 0) {
            if (index > this.images.length)
                this.ativo = 1
            else if (index < 1)
                this.ativo = this.images.length
            else
                this.ativo = index
        },
    },
}
</script>

<style lang="stylus" scoped src="./Banner.styl"></style>